import { Card } from "@redotech/arbiter/card";
import { RedoToggle } from "@redotech/arbiter/toggle/redo-toggle";
import * as gridCss from "@redotech/redo-web/grid.module.css";
import { groupInput, input, InputSchema } from "@redotech/ui/form";
import { memo } from "react";

export const reviewsGeneralForm = groupInput({ enabled: input<boolean>() });

export type ReviewsGeneralForm = InputSchema.Input<typeof reviewsGeneralForm>;

export type ReviewsGeneralValue = InputSchema.Value<typeof reviewsGeneralForm>;

export const reviewsGeneralDefault: ReviewsGeneralValue = { enabled: false };

export const ReviewsGeneralCard = memo(function ReviewsGeneralCard({
  input,
}: {
  input: ReviewsGeneralForm;
}) {
  const { enabled } = input.inputs;
  return (
    <Card title="Reviews">
      <section className={gridCss.grid}>
        <div className={gridCss.span6L}>
          <RedoToggle
            description="Enable Reviews product"
            label="Enabled"
            setValue={enabled.setValue}
            size="sm"
            value={enabled.value}
          />
        </div>
      </section>
    </Card>
  );
});
